// ヒーロースライダー設定
// backgroundType: 'animation'（visualType: shippouGold / techMesh / shippou / wave / fuji）
//                 / 'image'（backgroundImage） / 'gradient'（backgroundGradient） / 'video'（backgroundVideo）
// 文言は翻訳キーで持ち、HeroSlide 側で t() する（データに生の文字列を持たせない）。
export const heroSliderData = [
  // 1枚目：案A 和モダン・金の七宝
  {
    id: 1,
    titleKey: 'hero.slide1.title',
    subtitleKey: 'hero.slide1.subtitle',
    buttonTextKey: 'hero.slide1.button',
    buttonAction: 'news',
    backgroundType: 'animation',
    visualType: 'shippouGold',
    textColor: '#ffffff',
    textPosition: 'center',
    titleFont: 'serif',
  },

  // 2枚目：AYUBITO 多言語GPS音声ガイド（専用レイアウト）
  {
    id: 4,
    layout: 'ayubito',
    image: '/hero05-1.png',
    bgImage: '/hero-bg.png',
    ctaTextKey: 'ayubito.cta',
    ctaUrl: 'https://web.ayubito.com',
  },

  // 3枚目：案D テック / DX グラデーション
  {
    id: 2,
    titleKey: 'hero.slide2.title',
    subtitleKey: 'hero.slide2.subtitle',
    buttonTextKey: 'hero.slide2.button',
    buttonAction: 'work',
    backgroundType: 'animation',
    visualType: 'techMesh',
    textColor: '#ffffff',
    textPosition: 'center',
  },
];
